import {
  CertificationBuilder,
  GetCertificationsOutput,
} from '../certifications.types';

export const getCertifications = (builder: CertificationBuilder) =>
  builder.query<GetCertificationsOutput, number>({
    query: (candidateId) => ({
      url: `candidates/${candidateId}/certifications`,
      method: 'GET',
    }),
    providesTags: () => [{ type: 'Certification' }],
  });
